import { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export const UserCheck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M6.85396 9.20071C9.25535 9.20071 11.2065 11.1518 11.2065 13.5532C11.2065 14.0285 10.8062 14.4037 10.331 14.4037H0.850492C0.375217 14.4037 0 14.0285 0 13.5532C0 11.1518 1.92611 9.20071 4.3275 9.20071H6.85396ZM5.60324 8.00002C3.82721 8.00002 2.40139 6.57419 2.40139 4.79816C2.40139 3.04715 3.82721 1.59631 5.60324 1.59631C7.35425 1.59631 8.80509 3.04715 8.80509 4.79816C8.80509 6.57419 7.35425 8.00002 5.60324 8.00002ZM15.8091 4.97327C16.0593 5.1984 16.0593 5.57361 15.8342 5.82376L13.2327 8.62538C13.1326 8.75045 12.9575 8.80048 12.8074 8.80048C12.6323 8.80048 12.4822 8.75045 12.3822 8.62538L10.9813 7.22457C10.7312 6.99944 10.7312 6.62422 10.9813 6.39909C11.2065 6.14895 11.5817 6.14895 11.8068 6.39909L12.7824 7.34964L14.9586 4.99828C15.1838 4.74814 15.559 4.74814 15.8091 4.97327Z"
      fill="currentColor"
    />
  </svg>
);
